var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-popconfirm',{attrs:{"title":_vm.alertTitle,"okText":"确定","cancelText":"取消"},on:{"confirm":function($event){return _vm.$emit('onDelete')}}},[_c('a',{attrs:{"href":"javascript:;"}},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }